import { useState } from "react";
import { Check, Copy, Gift } from "lucide-react";

const T = {
  sk: { title: "Odporučte nás známemu", text: "Pošlite odkaz firme, ktorá potrebuje web. Dostane zľavu 10 % (web za €449,10) a vy mesiac plánu Pro zadarmo, keď zaplatí.", copy: "Kopírovať odkaz", copied: "Skopírované", count: "Zaplatené odporúčania" },
  cs: { title: "Doporučte nás známému", text: "Pošlete odkaz firmě, která potřebuje web. Dostane slevu 10 % (web za €449,10) a vy měsíc plánu Pro zdarma, až zaplatí.", copy: "Kopírovat odkaz", copied: "Zkopírováno", count: "Zaplacená doporučení" },
};

export const ReferralBox = ({ code, lang, count }) => {
  const t = T[lang];
  const [copied, setCopied] = useState(false);
  const link = `${window.location.origin}/tvorba-webu/${lang === "cs" ? "cz" : "sk"}/referencie?ref=${code}`;
  const copy = () => { navigator.clipboard.writeText(link); setCopied(true); setTimeout(() => setCopied(false), 2000); };
  return (
    <section className="mt-10 rounded-2xl border border-[#a3e635]/30 bg-[#a3e635]/[0.05] p-6" data-testid="proposal-referral">
      <h2 className="text-xl font-black flex items-center gap-2"><Gift className="w-5 h-5 text-[#a3e635]" />{t.title}</h2>
      <p className="mt-2 text-white/75">{t.text}</p>
      <div className="mt-4 flex flex-col sm:flex-row gap-2">
        <input readOnly value={link} className="flex-1 min-w-0 px-3 py-2.5 rounded-lg bg-white/10 text-white text-sm border border-white/10" onFocus={(e) => e.target.select()} data-testid="proposal-referral-link" />
        <button onClick={copy} className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-full bg-[#a3e635] text-black font-black hover:bg-[#bef264] transition-colors" data-testid="proposal-referral-copy">
          {copied ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />}{copied ? t.copied : t.copy}</button>
      </div>
      {count > 0 && <p className="mt-3 text-sm text-[#d9f99d]" data-testid="proposal-referral-count">{t.count}: {count}</p>}
    </section>
  );
};
